import type React from 'react';
import styled from 'styled-components';

import * as buttonStyles from '@/components/styles/button-styles';

const { button, ...styles } = buttonStyles;

export type AvoButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement>;

export const AvoButton = Object.assign(
  styled.button`
    ${buttonStyles.button}
  `,
  { styles },
);
